module.exports = __webpack_public_path__ + "static/media/choithramsRecipeFavourite.6131bd0d.png";